import { render, staticRenderFns } from "./verification-details.vue?vue&type=template&id=5e3e8c9e&"
import script from "./verification-details.vue?vue&type=script&lang=js&"
export * from "./verification-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports